import biboClient from './biboClient';

const axiosInstance = biboClient.create();

export default {
    getList: () => {
        return axiosInstance.get('/admin/api/tableauAuthConfig');
    },
    create: (data) => {
        return axiosInstance.post('/admin/api/tableauAuthConfig', data)
    },
    edit: (data) => {
        return axiosInstance.put(`/admin/api/tableauAuthConfig`, data)
    },
    delete: (id) => {
        return axiosInstance.delete(`/admin/api/tableauAuthConfig/${id}`)
    }
}